import React from 'react';
import { Box } from '@mui/material';

interface TypingIndicatorProps {
  isVisible?: boolean;
  color?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ 
  isVisible = true, 
  color = '#666' 
}) => {
  if (!isVisible) return null;

  return (
    <Box 
      className="typing-indicator"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        padding: '8px 12px',
        backgroundColor: '#f5f5f5',
        borderRadius: 2,
        maxWidth: 'fit-content'
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          className="typing-dot"
          sx={{
            width: 6,
            height: 6,
            backgroundColor: color,
            borderRadius: '50%',
            animation: 'typing 1.4s ease-in-out infinite',
            animationDelay: `${index * 0.2}s`,
            '@keyframes typing': {
              '0%, 60%, 100%': {
                transform: 'translateY(0)',
                opacity: 0.5
              },
              '30%': {
                transform: 'translateY(-8px)',
                opacity: 1
              }
            }
          }}
        />
      ))}
    </Box>
  );
};

export default TypingIndicator;